import React, { useEffect, useState } from 'react';
import { Alert, Box, Paper, Typography } from '@mui/material';
import api from '../../../../api/api';

const kinds = { pickup: 'Выдача клиенту', transfer: 'Перевозка курьером', load: 'Загрузка в постамат', placement: 'Размещение' };
const states = { in_transit: 'У курьера', completed: 'Завершено', cancelled: 'Отменено', prepared: 'Ожидает открытия', opened: 'Открыто, ожидает подтверждения' };

export default function AssetMovementHistory({ assetId, rentalPoints = [] }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    setHistory([]); setError(''); setLoading(true);
    api.get(`/locker/assets/${assetId}`).then(({ data }) => {
      if (active) setHistory(data.history || []);
    }).catch(() => {
      if (active) setError('Не удалось загрузить историю перемещений. Обновите страницу.');
    }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [assetId]);
  const pointName = id => rentalPoints.find(p => String(p.id) === String(id))?.name || `ПВЗ №${id}`;
  return <Paper variant="outlined" sx={{ mt: 3, p: 2 }}>
    <Typography variant="h6" component="h2">История перемещений</Typography>
    {loading && <Typography color="text.secondary">Загрузка перемещений…</Typography>}
    {error && <Alert severity="warning">{error}</Alert>}
    {!loading && !error && !history.length && <Typography color="text.secondary">Перемещения ещё не записаны</Typography>}
    {history.length === 100 && <Typography variant="caption">Показаны последние 100 операций.</Typography>}
    {history.map(h => <Box key={h.id} sx={{ py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
      <Typography fontWeight={600}>{kinds[h.kind] || h.kind} · {states[h.state] || h.state}</Typography>
      <Typography variant="body2">
        {new Date(h.created_at).toLocaleString('ru-RU')}{h.actor_name ? ` · ${h.actor_name}` : ''}
      </Typography>
      <Typography variant="body2">
        {h.kind === 'transfer'
          ? `Из: ${pointName(h.before?.rental_point_id || h.rental_point_id)}${h.after?.rental_point_id ? ` → ${pointName(h.after.rental_point_id)}` : ''}`
          : `${pointName(h.rental_point_id)}${h.cell_number != null ? ` · ячейка ${h.cell_number}` : ''}`}
      </Typography>
      {h.completed_at && <Typography variant="caption" color="text.secondary">Завершено: {new Date(h.completed_at).toLocaleString('ru-RU')}</Typography>}
    </Box>)}
  </Paper>;
}
